module.exports = __webpack_public_path__ + "img/oneToOne.edba7f32.png";